import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=8f4ea3c2&scoped=true"
import script from "./Advertising.vue?vue&type=script&lang=js"
export * from "./Advertising.vue?vue&type=script&lang=js"
import style0 from "./Advertising.vue?vue&type=style&index=0&id=8f4ea3c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4ea3c2",
  null
  
)

export default component.exports